import { Injectable } from '@angular/core';
import { Global } from '../globals';
import { RequestHelperProvider } from './../_services/request-helper';
import { CryptoService } from './../_services/crypto.service';
import { StorageKeys } from '../_constants';
import { StorageServiceProvider } from './services';
import utils from '../utils';

@Injectable({
  providedIn: 'root' 
})
export class AuthenticationService {
    constructor(private crypto: CryptoService, private helper: RequestHelperProvider, private globals: Global, private storage: StorageServiceProvider) { }

    login(sessionToken: string = '') {
        sessionStorage.setItem('isAuthenticated', 'true');
        sessionStorage.setItem('sessionToken', sessionToken);
        this.globals.isAuthenticated = true;
    }
    authenticateLogin(username, password, callback) {
        //let tenantID = this.storage.getTenantID();
        let beforeEncrptPassword = JSON.parse(JSON.stringify(password))
        let encryptedPassword = this.crypto.encryptString(password);
        this.getAgrisLicense(username, encryptedPassword, beforeEncrptPassword, (result, resultString) => {

            if (result === true) {
                callback(true);
            }
            else if (result === false) {
                callback(false, resultString);
            }

            else {
                callback(result);
            }
        })
    }

    releaseAgrisLicense(callback, failedcallback) {
        let tenantId = this.storage.getTenantID();
        if (!tenantId)
            return;

        let license = JSON.parse(localStorage.getItem('agrisLicense'));
        // this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/ReleaseLicense?TenantID=${tenantId}&UserID=${license.username}&Password=${encodeURIComponent(license.password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12&AgrisSessionId=${license.agrisLicense}`, {}

        this.ReleaseLicense(tenantId, license.username, license.password, license.agrisLicense).then(
            (data) => {
                data.Message == "True" ? callback(true) : callback(false);
            }, (error) => {
                failedcallback(error);
            })
    }
    async ReleaseLicense(tenantId, username, password, agrisLicense): Promise<any> {
        return new Promise(async (resolve, reject) => {
            var settings = this.storage.get(StorageKeys.Settings);
            let SessionID = settings ? settings.agentSessionId : null;
            let customerKey = settings ? settings.customerKey : null;
            let body = {
                "TenantID": tenantId,
                "UserID": username,
                "Password": encodeURIComponent(password),
                "ExtendedOption": "nko",
                "ExtendedOptionValue": "NAM12",
                "SessionID": SessionID,
                "AgrisSession": agrisLicense
            }
            let remoteUrl = utils.GetSalesReviewRemoteServer();

            await this.helper.Post((data: any) => {
                if (data) {
                    resolve(data);
                }
                else
                    reject('No Data Found!')
            }
                , `${remoteUrl}/AgrisLicense/ReleaseLicense`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }
    public getAgrisLicense(userId, password, beforeEncrptPassword, callback) {
        let tenantId = this.storage.getTenantID();
        if (!tenantId)
            return;

       // this.helper.PostServerCommand(`/culturahub/RESTCommandWebService/ExecuteServerCommand/AgrisLicenseProcessor/GetLicense?TenantID=${tenantId}&UserID=${userId}&Password=${encodeURIComponent(password)}&ExtendedOption=nko&ExtendedOptionValue=NAM12`, {}
       this.getLicense(tenantId, userId, password)
            .then((data) => {
                if (data.Message == "True") {
                    let license = {
                        username: userId,
                        password: password,
                        beforeEncrptPassword: beforeEncrptPassword,
                        agrisLicense: data.ResultString
                    }
                    localStorage.setItem('agrisLicense', JSON.stringify(license));
                    callback(true)
                } else { callback(false, data.ResultString) }
            })
            .catch((error) => {             
                callback(false, error);
            });
    }
  async getLicense(tenantId, username, password): Promise<any> {

        return new Promise(async (resolve, reject) => {
            var settings = this.storage.get(StorageKeys.Settings);
            let SessionID = settings ? settings.agentSessionId : null;
            let customerKey = settings ? settings.customerKey : null;
            let body = {
                "TenantID": tenantId,
                "UserID": username,
                "Password": encodeURIComponent(password),
                "ExtendedOption": "nko",
                "ExtendedOptionValue": "NAM12",
                "SessionID": SessionID
            }
            let remoteUrl = utils.GetSalesReviewRemoteServer();

            await this.helper.Post((data: any) => {
                    if (data) {
                        resolve(data);
                    }
                    else
                        reject('No Data Found!')
                }
                , `${remoteUrl}/AgrisLicense/GetLicense`
                , body
                , customerKey
                , SessionID
                , null
                , (error: any) => {
                    reject(error);
                },
                false,
                false,
            );
        });
    }
    public getUserPermissions(userId, callback, failedcallback) {
        let tenantId = this.storage.getTenantID();
        if (!tenantId)
            return;

        let settings = this.storage.get(StorageKeys.Settings);
        let remoteUrl = `/culturahub/RESTCommandWebService/ExecuteServerCommand/SecurityProcessor/GetEffectivePermissions?TenantID=${tenantId}&UserID=${userId}&Package=ACR,INV&SecurityOption=KIMPT,RIMPT,PIMPT,OVRMM&IgnoreSecurityLevels=True`;

        this.helper.PostServerCommand(remoteUrl, {}, (permissions) => {
            // console.log(permissions);
            callback(permissions);
        }, (error) => {
            failedcallback(error);
        });
    }
    logout() {
        sessionStorage.removeItem('isAuthenticated');
        sessionStorage.removeItem('sessionToken');
        localStorage.removeItem('agrisLicense');
        localStorage.removeItem('RefreshAgrisLicense');
        this.globals.isAuthenticated = false;
    }

    isLoggedIn() {
        let agrisLicense = localStorage.getItem('agrisLicense');
        return sessionStorage.getItem('isAuthenticated') != undefined && agrisLicense != undefined;
    }
}